import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import {
  Table,
  Icon,
  Alert,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  NotificationManager,
  Spinner,
} from "design-react-kit";

import secureLocalStorage from "react-secure-storage";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import ConfirmDeleteModal from "../Modals/ConfirmDeleteModal";
import {
  downloadFlow,
  filterHandler,
  showFlowType,
  showStatus,
  updateStagedFlowStatus,
} from "../../services/helpers";
import StagedFlowStatusEnum from "../../helpers/Enums/StagedFlowStatusEnum";
import { useSignIn, useSignOut } from "react-auth-kit";
import UserContext from "../../store/user-context";
import AuthModuleConfirmModal from "../Modals/AuthModuleConfirmModal";

const AuthModuleFlowsTable = ({ items, columns, getFlows }) => {
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [deleteFlowModalOpen, setDeleteFlowModalOpen] = useState(false);
  const [flowModalOpen, setFlowModalOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const [text, setText] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    setResults(items);
  }, [items]);

  const deleteFlow = (stagedFlowId) => {
    updateStagedFlowStatus(
      {
        stagedFlowId,
        status: StagedFlowStatusEnum.Deleted,
      },
      setIsLoading,
      signIn,
      signOut,
      navigate,
      userContext,
      setError,
      getFlows,
    );
  };

  const deleteFlowModalOpenHandler = (flow) => {
    setDeleteFlowModalOpen(true);
    setSelectedFlow(flow);
  };

  const deleteFlowModalCloseHandler = () => {
    setDeleteFlowModalOpen(false);
    setSelectedFlow(null);
  };

  const flowModalOpenHandler = (flow, status, text) => {
    const dropdowns = document.querySelectorAll(".dropdown-menu");

    dropdowns.forEach((item) => item.classList.remove("show"));

    setSelectedFlow(flow);
    setStatus(status);
    setText(text);
    setFlowModalOpen(true);
  };

  const flowModalCloseHandler = () => {
    setFlowModalOpen(false);
    setSelectedFlow(null);
  };

  return (
    <Fragment>
      {error !== null && error.length !== undefined && (
        <Alert color="danger" className="w-50 ml-auto mr-auto">
          {error.map((item) => (
            <p key={item}>{item}</p>
          ))}
        </Alert>
      )}

      {isLoading && (
        <p
          style={{
            height: "50px",
            position: "relative",
            marginBottom: "3rem",
          }}
        >
          <Spinner double active />
        </p>
      )}
      <div className="d-flex flex-column align-items-end justify-content-start w-100">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Cerca per nome del flusso"}
            column={"name"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getFlows()}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.id}>
                    <td className="predispositionDate">
                      {result.predispositionDate}
                    </td>
                    <td className="name">{result.name}</td>
                    <td className="clientCodeName">{result.clientCodeName}</td>
                    <td className="flowType">
                      {showFlowType(result.flowType)}
                    </td>
                    <td className="notificationsCount text-center">
                      {result.countAnNotifications +
                        result.countDigNotifications}
                    </td>
                    <td className="status text-center">{showStatus(result)}</td>
                    {result.stagedFlowStatusId ===
                      StagedFlowStatusEnum.ReadyForTechAuthorization && (
                      <td className="text-center initAuthflowsDropdown">
                        <UncontrolledDropdown className="table-dropdown">
                          <DropdownToggle>
                            <Icon icon="it-more-actions" fill="#06c" />
                            <Link to={null} className="moreActions">
                              Vedi azioni
                            </Link>
                          </DropdownToggle>
                          <DropdownMenu>
                            <div
                              className="d-flex align-items-center ml-2"
                              id="readyState"
                            >
                              <Icon icon="it-arrow-right-circle" fill="#06c" />
                              <Link
                                to={null}
                                className="start-authorization text-nowrap"
                                onClick={(e) =>
                                  flowModalOpenHandler(
                                    result,
                                    StagedFlowStatusEnum.TechAuthInProgress,
                                    "Confermi l'inizio del processo di verifica  tecnica?",
                                  )
                                }
                              >
                                Inizia verifica
                              </Link>
                            </div>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    )}
                    {(result.stagedFlowStatusId ===
                      StagedFlowStatusEnum.TechAuthInProgress ||
                      result.stagedFlowStatusId ===
                        StagedFlowStatusEnum.EconAuthInProgress ||
                      result.stagedFlowStatusId ===
                        StagedFlowStatusEnum.ReadyForEconAuthorization ||
                      result.stagedFlowStatusId ===
                        StagedFlowStatusEnum.EconNotApproved) && (
                      <td className="text-center authflowsDropdown">
                        <UncontrolledDropdown className="table-dropdown">
                          <DropdownToggle>
                            <Icon icon="it-more-actions" fill="#06c" />
                            <Link to={null} className="moreActions">
                              Vedi azioni
                            </Link>
                          </DropdownToggle>
                          <DropdownMenu>
                            <>
                              <div
                                className="d-flex align-items-center ml-2"
                                onClick={(e) => {
                                  secureLocalStorage.setItem(
                                    "flowName",
                                    result.name,
                                  );
                                  navigate(
                                    `/authModule/technicalFlows/notifications/${result.clientCodeName}/${result.id}/${result.flowType}`,
                                  );
                                }}
                              >
                                <Icon icon="it-password-visible" fill="#06c" />
                                <Link
                                  to={null}
                                  className="vediNotifiche"
                                  onClick={(e) =>
                                    navigate(
                                      `/authModule/technicalFlows/notifications/${result.clientCodeName}/${result.id}/${result.flowType}`,
                                    )
                                  }
                                >
                                  Vedi notifiche
                                </Link>
                              </div>
                              <hr />
                              <div
                                className="d-flex align-items-center ml-2"
                                style={{ cursor: "pointer" }}
                              >
                                <Icon icon="it-download" fill="#06c" />
                                <Link
                                  to={null}
                                  className="download text-nowrap"
                                  onClick={(e) =>
                                    downloadFlow(
                                      "DownloadFlow",
                                      result.id,
                                      setIsLoading,
                                      signIn,
                                      signOut,
                                      navigate,
                                      userContext,
                                      setError,
                                    )
                                  }
                                >
                                  Scarica flusso (dati)
                                </Link>
                              </div>
                              <div
                                className="d-flex align-items-center ml-2"
                                style={{ cursor: "pointer" }}
                              >
                                <Icon icon="it-download" fill="#06c" />
                                <Link
                                  to={null}
                                  className="download text-nowrap"
                                  onClick={(e) =>
                                    downloadFlow(
                                      "DownloadDocuments",
                                      result.id,
                                      setIsLoading,
                                      signIn,
                                      signOut,
                                      navigate,
                                      userContext,
                                      setError,
                                    )
                                  }
                                >
                                  Scarica flusso (allegati)
                                </Link>
                              </div>
                              {(result.stagedFlowStatusId ===
                                StagedFlowStatusEnum.TechAuthInProgress ||
                                result.stagedFlowStatusId ===
                                  StagedFlowStatusEnum.EconNotApproved) && (
                                <>
                                  <hr />
                                  <div className="d-flex align-items-center ml-2">
                                    <Icon icon="it-check-circle" fill="#06c" />
                                    <Link
                                      to={null}
                                      className="authorize text-nowrap"
                                      onClick={(e) =>
                                        flowModalOpenHandler(
                                          result,
                                          StagedFlowStatusEnum.TechAuthorized,
                                          "Sei sicuro di voler concedere l'autorizzazione tecnica",
                                        )
                                      }
                                    >
                                      Concedi autorizzazione
                                    </Link>
                                  </div>
                                  <div className="d-flex align-items-center ml-2">
                                    <Icon icon="it-close-circle" fill="#06c" />
                                    <Link
                                      to={null}
                                      className="not-authorize text-nowrap"
                                      onClick={(e) =>
                                        flowModalOpenHandler(
                                          result,
                                          StagedFlowStatusEnum.TechNotAuthorized,
                                          "Sei sicuro di voler negare l'autorizzazione tecnica",
                                        )
                                      }
                                    >
                                      Nega autorizzazione
                                    </Link>
                                  </div>
                                  <hr />
                                  <div className="d-flex align-items-center ml-2">
                                    <Icon icon="it-delete" fill="#06c" />
                                    <Link
                                      to={null}
                                      className="not-authorize text-nowrap"
                                      onClick={(e) =>
                                        deleteFlowModalOpenHandler(result)
                                      }
                                    >
                                      Rimuovi flusso
                                    </Link>
                                  </div>
                                </>
                              )}
                            </>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    )}
                  </tr>
                );
              })}
            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <ConfirmDeleteModal
          confirmModalOpen={deleteFlowModalOpen}
          confirmModalCloseHandler={deleteFlowModalCloseHandler}
          flowId={selectedFlow?.id}
          target={selectedFlow?.name}
          error={error}
          isLoading={isLoading}
          text={"Stai per eliminare il flusso"}
          actionHandler={deleteFlow}
          confirmButtonText="Sì, elimina"
        />
        <AuthModuleConfirmModal
          confirmModalOpen={flowModalOpen}
          confirmModalCloseHandler={flowModalCloseHandler}
          stagedFlowId={selectedFlow?.id}
          target={selectedFlow?.name}
          error={error}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setError={setError}
          getFlows={getFlows}
          status={status}
          text={text}
        />
      </div>

      <div>
        <NotificationManager
          containerId="table-user-message"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
    </Fragment>
  );
};

export default AuthModuleFlowsTable;
